import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs/operators';

const WARN_MS = 5000;

export const watchdogInterceptor: HttpInterceptorFn = (req, next) => {
  const tag = `${req.method} ${req.urlWithParams}`;
  const timer = setTimeout(() => console.warn('⚠️ Still pending > %dms:', WARN_MS, tag), WARN_MS);
  return next(req).pipe(finalize(() => clearTimeout(timer)));
};
